// eslint-disable-next-line @typescript-eslint/no-var-requires
const appVersion = require('../../package.json').version;

export const environment = {
  appVersion: appVersion,
  production: true,
  apiUrl: 'https://strike-2850-api.unitehere.org/Strike',
  apiHostHeader: 'strike-2850-api.unitehere.org',
  localNumber: '2850',
  deploymentType: 'production'
};
